export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser()
  // debugger
  if (!user.value) {
    return navigateTo('/login')
  }
})
